import React from "react";
import { Helmet } from "react-helmet-async";
import { SEO_DEFAULTS } from "../../seo/seoConstants";

interface SeoProps {
  title: string;
  description?: string;
  canonical?: string;
}

const Seo: React.FC<SeoProps> = ({ title, description, canonical }) => {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={SEO_DEFAULTS.ogImage} />
    </Helmet>
  );
};

export default Seo;
